module.exports = __webpack_public_path__ + "static/media/emergency.6ce79d09.svg";